/** Sub-threshold finger movement still selects a place/zone in booking mode. */
export const BOOKING_SELECTION_DRAG_THRESHOLD_PX = 6;

/**
 * Viewport pan starts only after this movement (pixi-viewport `threshold`).
 * Must stay above {@link BOOKING_SELECTION_DRAG_THRESHOLD_PX} so taps win over pan.
 */
export const BOOKING_VIEWPORT_DRAG_THRESHOLD_PX = 10;
